var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.relatedDocumentsControl),function(data){return _c('RelatedDocumentsItem',{attrs:{"v-key":data.id,"item":data}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }